import React, { useId } from "react";

import { CATALOG_TEXT, FILTER_MAX_CHARS, HISTORY_TEXT } from "./catalogText";
import { BTN_FIELD, FILTER_INPUT, FILTER_LABEL, ProductCategoryFilter } from "./CatalogFilters";

const F = HISTORY_TEXT.filters;

function Choice({ id, label, value, all, options, onChange }) {
  return (
    <div>
      <label htmlFor={id} className={FILTER_LABEL}>{label}</label>
      <select id={id} className={FILTER_INPUT} value={value} onChange={(e) => onChange(e.target.value)}>
        {all !== undefined && <option value="">{all}</option>}
        {options.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
      </select>
    </div>
  );
}

/** The cause dropdown: the strip's causes, plus the chosen one when its last case left the strip (the filter stays valid). */
const causeOptions = (causes, items, selected) => {
  const listed = causes.map((c) => ({ key: c.cause_id, label: c.cause_label }));
  if (!selected || listed.some((o) => o.key === selected)) return listed;
  const row = items.find((i) => i.cause_id === selected);
  return [...listed, { key: selected, label: row ? row.cause_label : selected }];
};

/** The history's filters bar: product -> category, cause, outcome, status, source, date range and a debounced search. */
export default function HistoryFilters({ filters, products, options, causes, items, onChange, onClear }) {
  const id = useId();
  const set = (key) => (value) => onChange(key, value);
  return (
    <section aria-label={F.label} className="mb-4 rounded-xl border border-[#EBECE6] bg-white p-3">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
        <div>
          <label htmlFor={`${id}-q`} className={FILTER_LABEL}>{F.search}</label>
          <input id={`${id}-q`} type="search" className={FILTER_INPUT} maxLength={FILTER_MAX_CHARS} placeholder={F.searchHint}
            autoComplete="off" value={filters.q} onChange={(e) => onChange("q", e.target.value)} />
        </div>
        <ProductCategoryFilter product={filters.product} category={filters.category} products={products} onChange={onChange}
          withCounts={false} />
        <Choice id={`${id}-cause`} label={F.cause} value={filters.cause} all={F.allCauses}
          options={causeOptions(causes, items, filters.cause)} onChange={set("cause")} />
        <Choice id={`${id}-kind`} label={F.kind} value={filters.kind} all={F.allKinds} options={options.kinds} onChange={set("kind")} />
        <Choice id={`${id}-status`} label={F.status} value={filters.status} all={F.allStatuses} options={options.statuses}
          onChange={set("status")} />
        <Choice id={`${id}-source`} label={F.source} value={filters.manual} options={HISTORY_TEXT.sources} onChange={set("manual")} />
        <div>
          <label htmlFor={`${id}-from`} className={FILTER_LABEL}>{F.from}</label>
          <input id={`${id}-from`} type="date" className={FILTER_INPUT} value={filters.date_from} max={filters.date_to || undefined}
            onChange={(e) => onChange("date_from", e.target.value)} />
        </div>
        <div>
          <label htmlFor={`${id}-to`} className={FILTER_LABEL}>{F.to}</label>
          <input id={`${id}-to`} type="date" className={FILTER_INPUT} value={filters.date_to} min={filters.date_from || undefined}
            onChange={(e) => onChange("date_to", e.target.value)} />
        </div>
        <div className="flex items-end">
          <button type="button" onClick={onClear} className={BTN_FIELD}>{CATALOG_TEXT.filters.clear}</button>
        </div>
      </div>
    </section>
  );
}
